<template>
  <el-card
    class="ds-detail"
    style="position: relative; z-index: 0; width: 100%"
  >
    <div slot="header" class="clearfix" v-if="backVisible">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ item.Name }}</el-tag>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <table
          border="1"
          bordercolor="#dedede"
          style="width: 100%; border-collapse: collapse"
        >
          <tr>
            <th width="12%">站点名称</th>
            <td width="38%">{{ item.Name }}</td>
            <th width="12%">站点类型</th>
            <td width="38%">
              <div v-if="item.StationType">{{ item.StationType.Name }}</div>
            </td>
          </tr>
          <tr>
            <th>业务类型</th>
            <td>
              <div v-if="item.BusinessType">{{ item.BusinessType.Name }}</div>
            </td>
            <th>区域</th>
            <td>
              <span v-if="item.Province">{{ item.Province.Name }}</span>
              <span v-if="item.City">/{{ item.City.Name }}</span>
              <span v-if="item.County">/{{ item.County.Name }}</span>
            </td>
          </tr>
          <tr>
            <th>站点状态</th>
            <td>
              <div v-if="item.StationState===1">运行</div>
              <div v-if="item.StationState===2">停运</div>
            </td>
            <th>详细地址</th>
            <td>{{ item.Address }}</td>
          </tr>
          <tr>
            <th>PIN号</th>
            <td>{{ item.PIN }}</td>
            <th>MN号</th>
            <td>{{ item.MN }}</td>
          </tr>
          <tr>
            <th>网络情况</th>
            <td>
              <div v-if="item.NetWorkType===0">有线</div>
              <div v-if="item.NetWorkType===1">无线</div>
            </td>
            <th>SIM卡序列号</th>
            <td>{{ item.SIM }}</td>
          </tr>
          <tr>
            <th>联网状态</th>
            <td>
              <div v-if="item.NetWorkingState" v-show="!stateVisible">
                <span
                  style="margin-right: 20%"
                  v-if="item.NetWorkingState === 1"
                >
                  已联网
                </span>
                <span
                  style="margin-right: 20%"
                  v-if="item.NetWorkingState === 2"
                >
                  更换中
                </span>
                <span
                  style="margin-right: 20%"
                  v-if="item.NetWorkingState === 3"
                >
                  已过保
                </span>
                <el-button
                  type="primary"
                  @click.stop="onEditState()"
                  title="编辑"
                >
                  <i class="fas fa-pencil-alt"></i>
                </el-button>
              </div>
              <div v-show="stateVisible">
                <el-select
                  v-model="item.NetWorkingState"
                  clearable
                  placeholder="请选择联网状态"
                  style="width: 150px"
                >
                  <el-option label="已联网" :value="1"></el-option>
                  <el-option label="更换中" :value="2"></el-option>
                  <el-option label="已过保" :value="3"></el-option>
                </el-select>
                <el-button
                  type="primary"
                  @click.stop="onChangeState()"
                  title="确认"
                >
                  <i class="fas fa-check-circle"></i>
                </el-button>
              </div>
            </td>
            <th>入网日期</th>
            <td>
              <div v-if="item.NetDay">{{ item.NetDay.substring(0, 10) }}</div>
            </td>
          </tr>
          <tr>
            <th>合同类型</th>
            <td>
              <div v-if="item.Code">
                <div v-if="item.Code.Contract">
                  <div v-if="item.Code.Contract.ContractType">
                    {{ item.Code.Contract.ContractType.Name }}
                  </div>
                </div>
              </div>
            </td>
            <th>合同年限</th>
            <td>
              <div v-if="item.Code">
                <div v-if="item.Code.Contract">
                  {{ item.Code.Contract.QATime }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>合同开始日期</th>
            <td>
              <div v-if="item.Code">
                <div v-if="item.Code.Contract">
                  <div v-if="item.Code.Contract.ContractStartDay">
                    {{ item.Code.Contract.ContractStartDay.substring(0, 10) }}
                  </div>
                </div>
              </div>
            </td>
            <th>合同结束日期</th>
            <td>
              <div v-if="item.Code">
                <div v-if="item.Code.Contract">
                  <div v-if="item.Code.Contract.ContractEndDay">
                    {{ item.Code.Contract.ContractEndDay.substring(0, 10) }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>备注</th>
            <td colspan="3">{{ item.Remark }}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="运维信息">
        <table
          border="1"
          bordercolor="#dedede"
          style="width: 100%; border-collapse: collapse"
        >
          <tr>
            <th width="12%">运维单位</th>
            <td width="38%" colspan="3">{{ item.Unit }}</td>
          </tr>
          <tr>
            <th width="12%">运维人员</th>
            <td width="38%">{{ item.Personnel }}</td>
            <th width="12%">联系方式</th>
            <td width="38%">{{ item.Phone }}</td>
          </tr>
          <tr>
            <th>TV ID</th>
            <td>{{ item.TVID }}</td>
            <th>TV 密码</th>
            <td>{{ item.TVPWD }}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="软硬件信息">
        <div class="border-style">软件产品信息</div>
        <table
          border="1"
          bordercolor="#dedede"
          style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 15px;
          "
        >
          <tr>
            <th width="12%">当前产品</th>
            <td width="38%">
              <div v-if="item.Code">
                <div v-if="item.Code.Software">
                  {{ item.Code.Software.Name }}_{{ item.CurrentVersion }}_{{
                    item.Code.Function.Name
                  }}
                </div>
              </div>
            </td>
            <th width="12%">目标产品</th>
            <td width="38%">
              <div v-if="item.Code">
                <div v-if="item.Code.TargetSoftware">
                  {{ item.Code.TargetSoftware.Name }}_{{
                    item.Code.TargetVersion
                  }}_{{ item.Code.TargetFunction.Name }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>授权码</th>
            <td>
              <div v-if="item.Code">{{ formatStr(item.Code.Name) }}</div>
            </td>
            <th>机器码</th>
            <td>
              <div v-if="item.Code">{{ item.Code.MachineCode }}</div>
            </td>
          </tr>
          <tr>
            <th width="12%">工控机品牌</th>
            <td width="38%">
              <div v-if="item.IpcDevice">{{ item.IpcDevice.Brand }}</div>
            </td>
            <th width="12%">工控机型号</th>
            <td width="38%">
              <div v-if="item.IpcDevice">{{ item.IpcDevice.ModelNumber }}</div>
            </td>
          </tr>
          <tr>
            <th>CPU</th>
            <td>
              <div v-if="item.IpcDevice">{{ item.IpcDevice.CPU }}</div>
            </td>
            <th>内存</th>
            <td>
              <div v-if="item.IpcDevice">{{ item.IpcDevice.Memory }}</div>
            </td>
          </tr>
          <tr>
            <th>操作系统版本</th>
            <td>
              <div v-if="item.IpcDevice">{{ item.IpcDevice.OSVer }}</div>
            </td>
            <th>操作系统安装时间</th>
            <td>
              <div v-if="item.IpcDevice">
                <div v-if="item.IpcDevice.OSSetupDt">
                  {{ item.IpcDevice.OSSetupDt.substring(0, 10) }}
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div class="border-style" v-if="item.IpcProduct">硬件产品信息</div>
        <table
          border="1"
          bordercolor="#dedede"
          style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 15px;
          "
          v-if="item.IpcProduct"
        >
          <tr height="40">
            <th width="15%">产品型号名称</th>
            <td width="35%">
              <div v-if="item.IpcProduct.IpcProductModel">
                {{ item.IpcProduct.IpcProductModel.Name }}
              </div>
            </td>
            <th width="15%">产品型号</th>
            <td width="35%">
              <div v-if="item.IpcProduct.IpcProductModel">
                {{ item.IpcProduct.IpcProductModel.Number }}
              </div>
            </td>
          </tr>
          <tr height="40">
            <th>产品SN</th>
            <td>{{ item.IpcProduct.SN }}</td>
            <th>机器码</th>
            <td>
              {{ item.IpcProduct.MachineCode }}
            </td>
          </tr>
          <tr height="40">
            <th>质保开始日期</th>
            <td v-if="item.IpcProduct.QualityStartAt">
              {{ $sys.dateFormat(item.IpcProduct.QualityStartAt, "Y-m-d") }}
            </td>
            <td v-else></td>
            <th>质保结束日期</th>
            <td v-if="item.IpcProduct.QualityEndAt">
              {{ $sys.dateFormat(item.IpcProduct.QualityEndAt, "Y-m-d") }}
            </td>
            <td v-else></td>
          </tr>
          <tr height="40">
            <th>客户</th>
            <td>
              <div v-if="item.IpcProduct.Client">
                {{ item.IpcProduct.Client.ClientName }}
              </div>
            </td>
            <th>出库日期</th>
            <td v-if="item.IpcProduct.StockoutAt">
              {{ $sys.dateFormat(item.IpcProduct.StockoutAt, "Y-m-d") }}
            </td>
            <td v-else></td>
          </tr>
          <tr height="40">
            <th>出库单号</th>
            <td>{{ item.IpcProduct.CheckoutNo }}</td>
            <th>出库经办人</th>
            <td>{{ item.IpcProduct.Operator }}</td>
          </tr>
          <tr height="40">
            <th>领用人</th>
            <td>{{ item.IpcProduct.Recipient }}</td>
            <th>状态</th>
            <td>{{ item.IpcProduct.StatusName }}</td>
          </tr>
          <tr height="40">
            <th>出库备注</th>
            <td colspan="3">{{ item.IpcProduct.StockoutReason }}</td>
          </tr>
          <tr height="40">
            <th>附件</th>
            <td colspan="3">
              <div
                style="text-align: left; font-size: smaller"
                v-if="
                  item.IpcProduct.DownloadUrls &&
                  item.IpcProduct.DownloadUrls.length > 0
                "
              >
                <span
                  style="padding-left: 10px"
                  v-for="attachment in item.IpcProduct.DownloadUrls"
                  :key="attachment.Url"
                >
                  <a
                    target="_blank"
                    :href="attachment.Url"
                    :download="attachment.Name"
                    style="color: #409eff"
                    >{{ attachment.Name }}</a
                  >
                </span>
              </div>
            </td>
          </tr>
        </table>

        <div
          class="border-style"
          v-if="item.IpcProduct && item.IpcProduct.IpcAccessories"
        >
          相关配件信息
        </div>
        <el-table
          :data="item.IpcProduct.IpcAccessories"
          v-if="item.IpcProduct && item.IpcProduct.IpcAccessories"
        >
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column prop="IpcAccessoryModel.Name" label="配件名称" />
          <el-table-column
            prop="IpcAccessoryModel.Brand"
            label="品牌"
            width="150"
          />
          <el-table-column
            prop="IpcAccessoryModel.ModelNumber"
            label="型号"
            width="150"
          />
          <el-table-column prop="SN" label="配件SN" width="200">
            <template slot-scope="scope">
              <el-tag>
                {{ scope.row.SN }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="出库日期" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.StockoutAt">{{
                $sys.dateFormat(row.StockoutAt, "Y-m-d")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="质保开始日期" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.QualityStartAt">{{
                $sys.dateFormat(row.QualityStartAt, "Y-m-d")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="质保结束日期" width="100">
            <template slot-scope="{ row }">
              <span v-if="row.QualityEndAt">{{
                $sys.dateFormat(row.QualityEndAt, "Y-m-d")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="软件生命周期">
        <el-timeline v-if="item.LifeCycle" :reverse="true">
          <el-timeline-item
            v-for="cycle in item.LifeCycle"
            :timestamp="$sys.dateFormat(new Date(cycle.CreatedAt))"
            placement="top"
            color="#0bbd87"
            size="large"
            :key="cycle.ID"
          >
            <el-card>
              <!-- <h4>更新生命周期</h4> -->
              <p>{{ cycle.Execution }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
      <el-tab-pane label="下位配置备份">
        <el-table :data="item.IpcBackups" v-loading="loading" size="medium">
          <el-table-column
            type="index"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          />
          <el-table-column prop="FileName" label="文件名" />
          <el-table-column prop="CreatedAt" label="上传时间" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.CreatedAt">
                {{ scope.row.CreatedAt.substring(0, 10) }} {{scope.row.CreatedAt.substring(11, 19)}}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="BackupAt" label="备份时间" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.BackupAt">
                {{ scope.row.BackupAt.substring(0, 10) }} {{scope.row.BackupAt.substring(11, 19)}}</span
              >
            </template>
          </el-table-column>
          <el-table-column width="100" label="操作">
            <template slot-scope="{ row }">
              <el-link target="_blank" :href="row.Url" :underline="false">
                <el-button
                  type="primary"
                  :disabled="row.Url === ''"
                  title="下载配置备份文件"
                >
                  <i class="fas fa-download"></i></el-button
                >
              </el-link>
              <el-button type="danger" @click.stop="onDeleteBackupFile(row.ID)" title="删除配置备份文件" style="margin-left:5px;">
                <i class="fas fa-trash"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
export default {
  props: ["ID", "showBack"],
  data() {
    return {
      activeName: "0",
      item: {},
      former: {
        Begin_at: null,
        Finish_at: null,
        data: 1,
      },
      itemList: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      stateVisible: false,
      loading: false,
      visible1: false,
      visible2: false,
      // 通过审核按钮的禁用
      disChkDeviceBtn: false,
      // 还原审核状态按钮的禁用
      disUnchkdeviceBtn: false,
      backVisible: true,
      stationID: "",
    };
  },
  mounted() {
    this.init();
    this.getItemData();
  },
  methods: {
    init() {
      //直接路由跳转页面
      if (this.$route.params.ID) {
        this.stationID = this.$route.params.ID;
      }
      //通过弹框嵌入该页面
      if (this.ID) {
        this.stationID = this.ID;
      }
      //通过弹框嵌入该页面，不显示返回按钮和点位名称
      if (this.showBack === false) {
        this.backVisible = false;
      }
    },
    getItemData() {
      const params = {
        with: [
          "Code.Function",
          "Code.BusinessType",
          "Code.Contract.ContractType",
          "Code.Software",
          "BusinessType",
          "Platforms",
          "IpcDevice",
          "StationType",
          "Province",
          "City",
          "County",
          "Code.TargetFunction",
          "Code.TargetSoftware",
          "LifeCycle",
        ],
      };
      this.$axios
        .get(`station/${this.stationID}`, { params })
        .then((response) => {
          this.item = response.data;  
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getItemList() {},
    handleClick() {},
    onSubmitQuery() {},
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditState() {
      this.stateVisible = true;
    },
    onChangeState() {
      this.$axios
        .put(`stationcheck/${this.stationID}`, {
          NetWorkingState: this.item.NetWorkingState,
        })
        .then(() => {
          this.getItemData();
          this.stateVisible = false;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
      // this.getItemData();
      // this.stateVisible = false;
    },
    formatStr(str) {
      let value = "";
      if (str) {
        for (let i = 0; i < 5; i++) {
          if (i === 0) {
            value = str.substring(0, 5);
          } else if (str.substring(i * 5, i * 5 + 5)) {
            value = `${value}-${str.substring(i * 5, i * 5 + 5)}`;
          }
        }
      }
      return value;
    },
    onDeleteBackupFile(backupFileId) {
      this.$confirm('请确认是否删除该备份文件?', '删除备份文件', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.delete(`station/backup/${backupFileId}`).then(() => {
          this.item.IpcBackups.splice(this.item.IpcBackups.findIndex(e => e.ID === backupFileId), 1);
          this.$message({
            type: 'success',
            message: '备份文件删除成功!',
          });
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
      }).catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: center;
    // padding-left: 5px;
    color: #646566;
    background-color: #ecf5ff;
    font-size: 11px;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 13px;
    font-weight: bolder;
  }
}
// .ds-detail {
//   .el-tabs__header {
//     z-index: 0;
//   }
//   .fix-width {
//     width: 120px;
//   }
//   table th td,
//   table tr td {
//     padding: 2px 5px;
//     height: 30px;
//     line-height: 30px;
//   }
//   table th {
//     text-align: left;
//     padding-left: 5px;
//     color: #646566;
//   }
//   .border-style {
//     height: 28px;
//     line-height: 28px;
//     border-radius: 0 15px 15px 0;
//     border-left: 3px solid #cdcdcd;
//     padding-left: 5px;
//     margin-bottom: 10px;
//     background-color: #ebf3f9;
//     color: #646566;
//   }
// }
</style>
